import React from "react";
import { Col } from "react-bootstrap";

function Ingredient(props) {
  return (
    <Col xs={6}>
      <p>
        - {props.quant} {props.ingred}
      </p>
    </Col>
  );
}

export default Ingredient;
